/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ShapeStandingList = {
    type: 'array',
    contains: {
        type: 'ShapeStanding',
    },
} as const;
